import {
    Card,
    Col,
    Row,
    Descriptions,
    Button, Skeleton, Result, Tag
} from "antd";
import React from "react";
import { useGetJobDetails } from "api/jobs/useGetJobDetails";
import { useNavigate, useParams } from "react-router-dom";
import { EditFilled } from "@ant-design/icons";
import { JOB_STATUS } from "api/jobs/dto.ts";
import { InfoCircleOutlined } from "@ant-design/icons";


const ViewPage: React.FC = () => {
    const { id } = useParams();
    const navigation = useNavigate();
    const {
        data,
        isLoading: isDetailsLoading,
        error: dError,
    } = useGetJobDetails(id);


     const getStatusColor = (status: JOB_STATUS | undefined): string => {
         switch (status) {
           case JOB_STATUS.DRAFT:
             return 'cyan';
           case JOB_STATUS.PUBLISHED:
             return 'green';
           case JOB_STATUS.FILLED:
             return 'geekblue';
           case JOB_STATUS.EXPIRED:
             return 'red';
           default:
             return 'default'; // Fallback color
         }
       };

    // Local helper to format deadline dates.
    const formatDeadline = (deadline: any): string => {
        if (!deadline) return "No Deadline";
        if (typeof deadline.toDate === "function") {
            return deadline.toDate().toLocaleDateString();
        }
        return new Date(deadline).toLocaleDateString();
    };

    if (isDetailsLoading) {
        return (
            <Card style={{ width: "100%", marginTop: 16, height: "580px" }}>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
            </Card>
        );
    }

    if (dError) {
        return (
            <Result
                status="error"
                title="Server Error"
                subTitle="There seems to be a problem with the server. Please check after a few minutes."
            />
        );
    }

    return (
        <>
            <div className="bg-background">
                <div className="max-w-6xl mx-auto py-2">
                    <div className="flex justify-between pt-2 mb-3">
                    <Tag className=" align-middle text-base pt-2 px-5  " color= {getStatusColor(data?.status)}> 
                        <InfoCircleOutlined /> Status: {" "}
                        {data?.status}
                        </Tag>
                        <Button
                            className="h-12 px-8 border-2 border-border text-base flex items-center gap-2"
                            onClick={() => navigation(`/recruiter/update-job/${id}`)}
                        >
                            <EditFilled />
                            Edit
                        </Button>
                    </div>
                    <Col className="flex flex-col gap-3">
                        <Card>
                            <Row gutter={16} align="top">
                                <Col span={6}>
                                    <strong>Job Title:</strong>
                                </Col>
                                <Col span={18}>{data?.jobTitle || "-"}</Col>
                            </Row>
                        </Card>
                        <Card>
                            <Row gutter={16} align="top">
                                <Col span={6}>
                                    <strong>Company Name:</strong>
                                </Col>
                                <Col span={18}>{data?.companyName || "-"}</Col>
                            </Row>
                        </Card>
                        <Card>
                            <Row gutter={16} align="top">
                                <Col span={6}>
                                    <strong>Job Description:</strong>
                                </Col>
                                <Col span={18}>{data?.jobDescription || "-"}</Col>
                            </Row>
                        </Card>
                        <Card>
                            <Row gutter={16} align="top">
                                <Col span={6}>
                                    <strong>Job Type:</strong>
                                </Col>
                                <Col span={18}>{data?.jobType || "-"}</Col>
                            </Row>
                        </Card>
                        <Card>
                            <Row gutter={16} align="top">
                                <Col span={6}>
                                    <strong>Salary:</strong>
                                </Col>
                                <Col span={18}>
                                    {data?.salary.amount || "-"} / {data?.salary.period || "-"}
                                </Col>
                            </Row>
                        </Card>
                        <Card>
                            <Row gutter={16} align="top">
                                <Col span={6}>
                                    <strong>Experience:</strong>
                                </Col>
                                <Col span={18}>{data?.experience || "Not Specified"}</Col>
                            </Row>
                        </Card>
                        <Card>
                            <Row gutter={16} align="top">
                                <Col span={6}>
                                    <strong>Vacancy Details:</strong>
                                </Col>
                                <Col span={18}>
                                    <div className="px-4 mb-5 py-4">
                                        <Descriptions column={2}>
                                            <Descriptions.Item label="Number of Vacancy">
                                                {data?.numberOfVacancy || "-"}
                                            </Descriptions.Item>
                                            <Descriptions.Item label="Skills">
                                                {data?.skills?.length ? data.skills.join(", ") : "-"}
                                            </Descriptions.Item>
                                        </Descriptions>

                                        {data?.joblocation?.map((location, index) => (
                                            <Row gutter={8} style={{ marginTop: 8 }} key={index}>
                                                <Descriptions column={2} className="mt-2">
                                                    <Descriptions.Item label="Location">
                                                        {location.district || "-"}, {location.province || "-"}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label="Languages">
                                                        {location.languages && location.languages.length > 0
                                                            ? location.languages.join(", ")
                                                            : "N/A"}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                            </Row>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        </Card>

                        <Card>
                            <Row gutter={16} align="top">
                                <Col span={6}>
                                    <strong>Valid Until:</strong>
                                </Col>
                                <Col span={18}>
                                    {data?.deadlineAt ? formatDeadline(data?.deadlineAt) : "No Deadline"}
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </div>
            </div>
        </>
    );
};

export default ViewPage;
